/**
 * All global scripts
 */

document.addEventListener("DOMContentLoaded", (event) => {
  const header = document.getElementById("header");

  // header fixed
  if (window.innerWidth > 1200 && header) {
    window.addEventListener("scroll", function () {
      if (window.scrollY) {
        header.classList.add("fixed");
      } else {
        header.classList.remove("fixed");
      }
    });
  }
  // END header scripts
}); // end DOMContentLoaded


// btn "voir +" page détail produit 
let btnTruncate = document.querySelector('.btn-truncate-text');
if (btnTruncate) {
  btnTruncate.addEventListener('click', function() {
    let text = document.querySelector('.champ_txt_truncate_hide');
    if (text.classList.contains('js-show')) {
      text.classList.remove('js-show');
      btnTruncate.classList.remove('js-show');
      btnTruncate.innerHTML = 'Lire plus';
    } else {
      text.classList.add('js-show');
      btnTruncate.classList.add('js-show');
      btnTruncate.innerHTML = 'Lire moins';
    }
  });
}

/*	--------------------------------------------------
== slide scroll "haut de page"
-------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
    const backToTopBtn = document.querySelector('.btn-back-to-top');

    window.addEventListener('scroll', function () {
        if (window.scrollY > 100) {
            backToTopBtn.classList.add('visible');
        } else {
            backToTopBtn.classList.remove('visible');
        }
    });

    backToTopBtn.addEventListener('click', function (event) {
        event.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});

// bouton google trad
const menu = document.getElementById('google_translate_element');
const langBox = document.querySelector('.box-google-trad--lang');

// Ferme le menu si un clic se produit en dehors de celui-ci
document.addEventListener('mouseup', function(e) {
    if (!menu.contains(e.target) && e.target !== menu) {
        menu.classList.remove('js-show');
    }
});

// Affiche ou cache le menu lors d'un clic sur le bouton
langBox.addEventListener('click', function() {
    menu.classList.toggle('js-show');
});

// old script google trad en jquery
/*
const $menu = jQuery('#google_translate_element');

jQuery(document).mouseup(e => {
  if (!$menu.is(e.target)
  && $menu.has(e.target).length === 0)
  {
    $menu.removeClass('js-show');
  }
});

jQuery('.box-google-trad--lang').click(function() {
  jQuery('#google_translate_element').toggleClass('js-show');
});
*/
